import { render, staticRenderFns } from "./DispatchedOrders.vue?vue&type=template&id=8f370f0e"
import script from "./DispatchedOrders.vue?vue&type=script&lang=js"
export * from "./DispatchedOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports